<template>
  <div>
    <slot name="tagline" :product-availability="productAvailability" />
    <slot :product-availability="productAvailability" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      productAvailability: {
        hasResorts: false,
        hasLiveaboards: false,
        hasYachts: false,
        hasEcoventures: false
      }
    }
  },
  props: ['destinationId'],
  mounted () {
      $.ajax({
        method: 'POST',
        url: '/',
        data: {
          id: this.destinationId,
          action: 'zuBlu/public/getDestinationStructure',
          [window.Craft.csrfTokenName]: window.Craft.csrfTokenValue,
        },
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      })
      .then(structure => {
        
        const url = `${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v2/products_availability_query`
        const payload = {
          destination_structure: JSON.parse(structure)
        }

        return $.post(url, payload)
      })
      .then(availability => {
        this.productAvailability = availability
      })
  }
}
</script>